<template>
    <AtomsGlobalLink :to="props.url" class="flex min-h-[8rem] gap-2 justify-between items-center p-4 text-md text-right font-medium uppercase shadow-around hover:text-conversion border border-white hover:border-conversion ease-in-out duration-200 cursor-pointer">
        <AtomsImagesImage class="flex-shrink self-center min-w-0 max-w-[100px] lg:max-w-[140px]" :src="url" :alt="props.fullName" />
        <h2 v-html="props.name" class="flex-grow"></h2>
    </AtomsGlobalLink>
</template>
<script setup>

const props = defineProps({
    id: Number,
    name: String,
    fullName: String,
    url: String
});

const appConfig = useAppConfig();

const url = `/img/groups/${props.id}.png?v=2025`;

</script>